import { useEffect, useState } from "react";


export function useAnonResults() {
    const [results, setResults] = useState([]);

    useEffect(() => {
        const storedResults = localStorage.getItem("anonResults");
        if (storedResults) {
            setResults(JSON.parse(storedResults));
        }
    }, [])

    const saveResult = (result) => {
        localStorage.setItem("anonResults", JSON.stringify([...results, result]));
        setResults([...results, result]);
    }

    const clearResults = () => {
        localStorage.removeItem("anonResults");
        setResults([]);
    }

    return { results, saveResult, clearResults };
}